import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

// login() ist eine Seitennavigation — parallele Requests dürfen sie nur einmal auslösen.
let redirecting = false;

export const keycloakBearerInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const auth = inject(AuthService);

  const withAuth = (token: string): HttpRequest<unknown> =>
    req.clone({
      setHeaders: {
        'X-Libri-Client': 'labs-preisradar',
        Authorization: `Bearer ${token}`
      }
    });

  const redirectToLogin = () => {
    if (!redirecting) {
      redirecting = true;
      keycloak.login();
    }
  };

  return from(auth.getToken()).pipe(
    switchMap((token) => {
      if (!token) {
        redirectToLogin();
        return throwError(() => new Error('Keine gültige Sitzung — Weiterleitung zum Login.'));
      }

      return next(withAuth(token)).pipe(
        catchError((error: unknown) => {
          if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
            return throwError(() => error);
          }
          // Einmalig erzwungen erneuern und wiederholen. Ein zweiter 401 ist ein
          // Autorisierungsproblem — kein login(), sonst Reload-Schleife.
          return from(auth.refreshToken()).pipe(
            switchMap((fresh) => {
              if (!fresh) {
                redirectToLogin();
                return throwError(() => error);
              }
              return next(withAuth(fresh));
            })
          );
        })
      );
    })
  );
};
